import withLoader from './withLoader';
export var Loader = withLoader(function () { return import('./DataGridWrapper'); });
export var preloadDataGridV2 = function () { return Loader.preload(); };
export default Loader;
